import Image from 'next/image'
import {Swiper, SwiperSlide} from 'swiper/react'
import CustomLink from '../CustomLink'
import {Autoplay, Navigation} from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import Link from 'next/link'
import GetFeaturedProducts from '@/services/api/products/GetFeaturedProducts'
import {useQuery} from 'react-query'
import { useTranslation } from 'next-i18next'
import useUserPreferences from '@/hooks/useUserPreferences';
import { useRouter } from 'next/router'
//interface Props {
//most_sold_products: any
//}

//export default function MostSoldProducts({most_sold_products}: Props) {
export default function MostSoldProducts() {
  const preferences = useUserPreferences();
  const {locale} = useRouter();
  
  const { data: featured_products, isLoading, error } = useQuery(
    ['featured_products', preferences?.countryCode, preferences?.currencyCode],
    () => GetFeaturedProducts(preferences?.countryCode, preferences?.currencyCode),
    {
      enabled: !!preferences, // Only fetch when preferences are available
    }
  );
  const {t} = useTranslation('common');
  return (
    <div className="featured mt-24 container-fluid">
      <h1 className="text-success text-center font-bold text-3xl">
        {t('mostSoldBooks')}
      </h1>
      {/*
       *<div className="books-list mt-2 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-4 lg:gap-6">
       */}
      <div className="books-list mt-2 ">
        <Swiper
          autoplay={{delay: 3000}}
          spaceBetween={10}
          modules={[Navigation, Autoplay]}
          navigation={true}
          breakpoints={{
            // when window width is >= 640px
            640: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            960: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1366: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}>
          {featured_products?.map((product: any, idx: number) => {
            const demoName = locale === 'ar' 
              ? product?.demo_name?.ar || '' 
              : product?.demo_name?.en || '';
            const splitName = demoName.split('{basmti}');
            const name = locale === 'ar' ? product?.replace_name?.ar : product?.replace_name?.en;
            return (
              <SwiperSlide key={idx}>
                <div
                  key={product.id}
                  className="book relative  mt-4 h-[300px] lg:h-[320px] 2xl:h-[400px]">
                  <div className="book-text absolute w-full top-8">
                    <h2 className="text-primary font-bold text-center">
                      {splitName[0]}
                      <span>{name}</span>
                      {splitName[1]}
                    </h2>
                  </div>
                  <div className="book-image h-full">
                    <Image
                      src={
                        process.env.NEXT_PUBLIC_CDN_URL +
                        '/' +
                        product.images[0]
                      }
                      width={400}
                      height={400}
                      alt={product.product_name?.ar}
                      className="w-full rounded-md h-full object-cover"
                    />
                  </div>
                  <div className="absolute text-center bottom-6 left-0 right-0 max-w-[80%] mx-auto">
                    <CustomLink
                      href={'product/' + product.slug}
                      bg="primary"
                      classes={['w-full', 'font-semibold', 'py-3']}>
                      {`${t('mostSoldBooksButton')}`}
                    </CustomLink>
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className="browse-btn text-center">
        <Link
          href="/products"
          className="inline-block mt-6 border-2 border-primary text-primary text-center font-semibold rounded-lg px-12 py-[.9rem]">
          {t('viewMore')}
        </Link>
      </div>
    </div>
  )
}
